
import {FallbackLng} from 'i18next'
import {getEnvironment} from '../appconfig'

const {staticLocaleURL} = getEnvironment()

export const config = {
    backend: {loadPath: `${staticLocaleURL}/locales/{{lng}}/{{ns}}.json`},
    fallbackLng: false as false | FallbackLng | undefined,
    interpolation: {escapeValue: false}, // react already safe from xss
    keySeparator: '::',
    nsSeparator: ':::',
    returnEmptyString: false, // if value is missing use key as fallback
    supportedLngs: ['en', 'fi', 'sv'],
}
